import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const subeventregistrations = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
      subEventIDs: [],
      hasSubEvent: true,
    },
    selectedItems: [],
    loading: true,
  }),
  mutations: {
    setSubEventRegistrations(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedSubEventRegistrations(state, payload) {
      state.selectedItems = payload;
    },
    setSubEventRegistrationPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getSubEventRegistrations");
    },
    setSubEventRegistrationTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getSubEventRegistrations");
    },
  },
  actions: {
    async confirmSubEventRegistration(store, payload) {
      axios
        .post("Participant/ConfirmSubEventRegistration", {
          id: payload.item.id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            payload.context.$message.success(res.data.alert.message);
            store.state.items[payload.index].subEventRegistrations[
              payload.registrationIndex
            ].status = payload.status;
          }
        });
    },
    async cancelSubEventRegistration(store, payload) {
      axios
        .post("Participant/CancelSubEventRegistration", {
          id: payload.item.id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            payload.context.$message.success(res.data.alert.message);
            store.state.items[payload.index].subEventRegistrations[
              payload.registrationIndex
            ].status = payload.status;
          }
        });
    },
    async getSubEventRegistrations(store) {
      store.state.loading = true;
      await axios
        .post("participant/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setSubEventRegistrations", res.data.data);
        });
    },
    async toggleSubEventRegistration(store, payload) {
      var res = await axios.post("participant/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteSubEventRegistration(store, payload) {
      await axios
        .post("participant/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);

            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default subeventregistrations;



// WEBPACK FOOTER //
// ./src/store/subeventregistrations.js